const labEvents = (() => {
  function getCategory(item) {
    const kitKey = '_KitKey' in item.properties && item.properties._KitKey !== '';
    const kitParentVariant = item.properties._KitParentVariant === true;
    const kitName = theme.translations.product_kit_line_item_part_of;
    let category = item.product_type || item.item_category || '';

    if (kitKey && !kitParentVariant) {
      category = `${item.properties[kitName]}/${category}`;
    }
    return category;
  }

  function reduceItems(items) {
    // Aggregate items with the same id and price and update the quantity
    const reducedItems = items.reduce((accumulator, item) => {
      const existingItem = accumulator.find(
        (existing) =>
          item.id === existing.id &&
          item.final_price === existing.final_price &&
          item.final_price === 0
      );

      if (existingItem) {
        existingItem.quantity += item.quantity;
      } else {
        accumulator.push(item);
      }

      return accumulator;
    }, []);
    return reducedItems;
  }

  function publishProductAddedToCart(product, qty = 1) {
    const currency = Shopify.currency.active;
    const customData = {
      currency,
      value: product.final_price / 100,
      items: [
        {
          item_name: product.title,
          item_id: String(product.id),
          price: product.final_price / 100,
          currency,
          item_category: product.product_type,
          quantity: parseInt(qty, 10),
          item_brand: product.vendor,
        },
      ],
    };

    Shopify.analytics.publish('custom:product_added_to_cart', customData);
  }

  function publishStarterKitAddedToCart(customData) {
    const items = customData.data.map((item) => {
      return {
        item_name: item.name,
        item_id: item.id,
        price: item.price,
        item_category: getCategory(item),
        quantity: item.quantity,
        item_brand: item.vendor,
      };
    });

    const sum = customData.data.reduce((total, item) => total + item.price * item.quantity, 0);

    const eventData = {
      currency: customData.currency,
      value: sum,
      items,
    };

    Shopify.analytics.publish('starter_set_add_to_cart', eventData);
  }

  function publishProductRemovedFromCart(data) {
    const removedItems = {
      item_name: data.title,
      item_id: data.variant_id,
      price: data.final_price / 100,
      item_category: data.product_type,
      quantity: data.quantity,
      item_brand: data.vendor,
    };
    const totalValue = data.final_line_price / 100;

    const customData = {
      currency: Shopify.currency.active,
      value: totalValue,
      items: removedItems,
    };

    Shopify.analytics.publish('remove_from_cart', customData);
  }

  function publishStarterKitRemovedFromCart(data) {
    const kitParentVariant = data.find((item) => item.properties._KitParentVariant);

    const removedItems = data.map((item) => {
      const {properties, ...rest} = item; // Destructure properties from item
      return {
        ...rest,
        item_category: getCategory(item),
      };
    });

    const customData = {
      currency: Shopify.currency.active,
      value: kitParentVariant.price || 0,
      items: removedItems,
    };

    Shopify.analytics.publish('remove_from_cart', customData);
  }

  function publishBeginCheckout(data) {
    const customData = {
      data,
    };

    Shopify.analytics.publish('begin_checkout', customData);
  }

  function publishMenuClick(clickText) {
    const customData = {
      clickText,
    };
    Shopify.analytics.publish('menu_click', customData);
  }

  function publishCtaClick(trackingEnabled, buttonText) {
    if (!trackingEnabled) return;
    const customData = {
      buttonText,
    };
    Shopify.analytics.publish('cta_click', customData);
  }

  function publishFilterUsage(filterTags) {
    const customData = {
      filterTags,
    };
    Shopify.analytics.publish('filter_usage', customData);
  }

  function publishMenuOpened() {
    Shopify.analytics.publish('menu_opened');
  }

  function publishAccordionOpened(title, accordionState) {
    if (accordionState) {
      const customData = {
        title,
      };

      Shopify.analytics.publish('accordion_opened', customData);
    }
  }

  function publishFilterUsageStarterKitColor(filter) {
    const customData = {
      filterType: filter.type,
      color: filter.value,
      pageLocation: `${document.location.origin}${document.location.pathname}`,
    };

    Shopify.analytics.publish('filter_usage_starterkit', customData);
  }

  function publishFilterUsageStarterKitEffect(filter) {
    const customData = {
      filterType: filter.type,
      effect: filter.value,
      pageLocation: `${document.location.origin}${document.location.pathname}`,
    };

    Shopify.analytics.publish('filter_usage_starterkit', customData);
  }

  function publishSearchUsageStarterKit(searchTerm) {
    const customData = {
      searchTerm,
      pageLocation: `${document.location.origin}${document.location.pathname}`,
    };

    Shopify.analytics.publish('search_usage_starterkit', customData);
  }

  function publishKlaviyoForm() {
    window.addEventListener('klaviyoForms', function klaviyoFormsListener(event) {
      const eventData = event.detail;

      if (eventData.type !== 'submit' && eventData.type !== 'stepSubmit') return;

      const customData = {
        formId: eventData.formId,
        formSource: eventData.metaData.$source,
        type: eventData.type,
        formStep: eventData.metaData.$step_name || 'Submit Form',
        pageLocation: `${document.location.origin}${document.location.pathname}`,
        metaData: JSON.parse(JSON.stringify(eventData.metaData)),
      };

      // only track specific klaviyo events
      if (eventData.type === 'submit') {
        Shopify.analytics.publish('custom:klaviyo_form_submit', customData);
      } else if (eventData.type === 'stepSubmit') {
        Shopify.analytics.publish('custom:klaviyo_form_step', customData);
      }
    });
  }

  // Scroll depth tracking global variables
  let is25ScrollFired = false;
  let is50ScrollFired = false;
  let is75ScrollFired = false;
  let is100ScrollFired = false;

  function publishScrollDepth() {
    if (is100ScrollFired) return;

    const scrollDepth =
      (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

    if (scrollDepth > 25 && scrollDepth <= 50 && !is25ScrollFired) {
      Shopify.analytics.publish('custom:pageScroll', {percent: 25});
      is25ScrollFired = true;
    } else if (scrollDepth > 50 && scrollDepth <= 75 && !is50ScrollFired) {
      Shopify.analytics.publish('custom:pageScroll', {percent: 50});
      is50ScrollFired = true;
    } else if (scrollDepth > 75 && scrollDepth < 100 && !is75ScrollFired) {
      Shopify.analytics.publish('custom:pageScroll', {percent: 75});
      is75ScrollFired = true;
    } else if (scrollDepth >= 100 && !is100ScrollFired) {
      Shopify.analytics.publish('custom:pageScroll', {percent: 100});
      is100ScrollFired = true;
    }
  }

  function publishEngagementTime() {
    let engagementTime = 0;
    let interval;
    const engagementThreshold = 10000; // 10 seconds are required to trigger the event
    let eventSent = false; // Flag to check if event is already sent (prevent multiple firing for safari compat)

    // Start tracking time
    const startTimer = () => {
      interval = setInterval(() => {
        engagementTime += 1000;
      }, 1000);
    };

    // Stop tracking time and send custom event
    const stopTimerAndSendData = () => {
      if (eventSent) return; // Exit if event has already been sent
      clearInterval(interval);
      if (engagementTime >= engagementThreshold) {
        Shopify.analytics.publish('custom:engagement', {engagementTime});
        eventSent = true; // Set flag to true after sending the event
      }
    };

    try {
      startTimer();
      // Add unload event listener
      window.addEventListener('beforeunload', stopTimerAndSendData);
      // Add pagehide event listener for Safari mobile compatibility
      window.addEventListener('pagehide', stopTimerAndSendData);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error tracking user engagement:', error);
    }
  }

  function publishVarifyTrackingId() {
    try {
      // wait for 500ms to ensure the session key is set since its placed from another script
      setTimeout(() => {
        // find the session key that starts with varify-experiment-
        let sessionKey = Object.keys(sessionStorage).find((key) =>
          key.startsWith('varify-experiment-')
        );

        if (!sessionKey) return;

        // check if the varify tracker has already been executed (we only want to run this once even per session)
        const isVarifyTrackerExec = sessionStorage.getItem('varify-tracker-exec');

        if (isVarifyTrackerExec) return;

        const sessionValue = JSON.parse(sessionStorage.getItem(sessionKey));
        const {variationId} = sessionValue;

        // strip varify-experiment- from the key and convert to number
        sessionKey = parseInt(sessionKey.replace('varify-experiment-', ''), 10);

        const customData = {
          experiment_id: sessionKey,
          variation_id: variationId,
        };

        Shopify.analytics.publish('custom:varify-tracker', customData);

        // Add another session key to prevent multiple executions
        sessionStorage.setItem('varify-tracker-exec', true);
      }, 500);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error executing varify tracker:', error);
    }
  }

  function publishCartDrawerViewed(data) {
    const cart = data;
    if (cart?.items && cart.items.length > 0) {
      cart.items = reduceItems(cart.items);

      const cartItems = cart.items.map((item) => {
        return {
          item_name: item.title,
          item_id: item.variant_id,
          price: item.final_price / 100,
          item_category: getCategory(item),
          quantity: item.quantity,
          item_brand: item.vendor,
        };
      });

      const customData = {
        currency: cart.currency,
        value: cart.total_price / 100,
        items: cartItems,
      };

      Shopify.analytics.publish('cart_drawer_viewed', customData);
    }
  }

  function publishSetClickType(currentVariant) {
    const customData = {
      name: currentVariant.title,
    };

    Shopify.analytics.publish('click_starter_set_type', customData);
  }

  function publishProductInclusive(step) {
    const customData = {
      step,
    };

    Shopify.analytics.publish('select_product_inclusive', customData);
  }

  function publishProductOptional(name) {
    const customData = {
      name,
    };

    Shopify.analytics.publish('select_product_optional', customData);
  }

  function publishQuickPreview() {
    Shopify.analytics.publish('click_quick_preview');
  }

  function getSignupSource() {
    return {
      fromCheckoutPage: sessionStorage.getItem('came_from_postpurchase_widget'),
      clickedFromLoyaltyPage: sessionStorage.getItem('account_clicked_from_loyalty_page'),
      fromLoyaltyPage: sessionStorage.getItem('came_from_loyalty_page'),
    };
  }

  function publishAccountClicked() {
    const urlParams = new URLSearchParams(window.location.search);
    const fromCheckout = urlParams.has('from') && urlParams.get('from') === 'checkout';

    if (!fromCheckout) {
      sessionStorage.removeItem('came_from_postpurchase_widget');
    }

    if (document.location.pathname === theme.settings.loyalty_page_url && !fromCheckout) {
      sessionStorage.setItem('account_clicked_from_loyalty_page', true);
    } else {
      sessionStorage.removeItem('came_from_loyalty_page');
      sessionStorage.removeItem('account_clicked_from_loyalty_page');
    }
  }

  function publishSignupClick() {
    const {fromCheckoutPage, clickedFromLoyaltyPage} = getSignupSource();

    if (fromCheckoutPage) {
      Shopify.analytics.publish('click_signup_from_checkout');
      sessionStorage.setItem('came_from_postpurchase_widget', true);
    } else if (clickedFromLoyaltyPage) {
      Shopify.analytics.publish('click_signup_from_loyalty_page');
      sessionStorage.setItem('came_from_loyalty_page', true);
    }

    sessionStorage.removeItem('account_clicked_from_loyalty_page');
  }

  function publishSearchOpened() {
    Shopify.analytics.publish('search_opened');
  }

  return {
    publishProductAddedToCart,
    publishStarterKitAddedToCart,
    publishProductRemovedFromCart,
    publishBeginCheckout,
    publishMenuClick,
    publishCtaClick,
    publishFilterUsage,
    publishMenuOpened,
    publishAccordionOpened,
    publishFilterUsageStarterKitColor,
    publishFilterUsageStarterKitEffect,
    publishSearchUsageStarterKit,
    publishKlaviyoForm,
    publishScrollDepth,
    publishEngagementTime,
    publishVarifyTrackingId,
    publishCartDrawerViewed,
    publishSetClickType,
    publishProductInclusive,
    publishProductOptional,
    publishStarterKitRemovedFromCart,
    publishQuickPreview,
    publishAccountClicked,
    publishSignupClick,
    publishSearchOpened,
  };
})();

export const {
  publishProductAddedToCart,
  publishStarterKitAddedToCart,
  publishProductRemovedFromCart,
  publishBeginCheckout,
  publishMenuClick,
  publishCtaClick,
  publishFilterUsage,
  publishMenuOpened,
  publishAccordionOpened,
  publishFilterUsageStarterKitColor,
  publishFilterUsageStarterKitEffect,
  publishSearchUsageStarterKit,
  publishKlaviyoForm,
  publishScrollDepth,
  publishEngagementTime,
  publishVarifyTrackingId,
  publishCartDrawerViewed,
  publishSetClickType,
  publishProductInclusive,
  publishProductOptional,
  publishStarterKitRemovedFromCart,
  publishQuickPreview,
  publishAccountClicked,
  publishSignupClick,
  publishSearchOpened,
} = labEvents;
